let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("avXYJ")).then(() => parcelRequire('3zrQg'));